import * as React from "react";
import {InfoBanner} from "@ferry/portal-core";

export class NCDImpactedClaimBanner extends React.Component<{}> {

    public render(): React.ReactNode {
        return (
            <InfoBanner wording={
                <>
                    <span className="font-weight-bold">Heads up</span> - Your policy is cancelled, but due to the claim you've made we will
                    continue to collect the remaining monthly payments in line with your T&C's
                </>
            }/>
        )
    }
}
